import { z } from "zod";
export const StagedDeployProofV1Schema = z
    .object({
    schemaVersion: z.literal("staged-deploy-proof.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalStagedDeployProof(recordedAt) {
    return StagedDeployProofV1Schema.parse({
        schemaVersion: "staged-deploy-proof.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=staged-deploy-proof.js.map